import { CallStatus } from './vo/call/CallStatus';
import { CallEventType } from './vo/call/CallEventType';
import { CallReplayMethod } from './vo/call/CallReplayMethod';

class CallEvent {
  static isExpired = (callStatus: CallStatus) => (callStatus === CallStatus.Expired);

  static isPending = (callStatus: CallStatus) => (callStatus === CallStatus.Pending);

  static isLive = (callStatus: CallStatus) => (callStatus === CallStatus.Live);

  static isCanceled = (callStatus: CallStatus) => (callStatus === CallStatus.Canceled);

  static isDraft = (published: boolean) => (published === false);

  static isOacc = (callType: CallEventType) => (callType === CallEventType.Oacc);

  static isWebinar = (callType: CallEventType) => (callType === CallEventType.Webinar);

  static isMeeting = (callType: CallEventType) => (callType === CallEventType.Meeting);

  static isReplayActive = (replayMethod: CallReplayMethod) => (replayMethod !== CallReplayMethod.None);

  static isReplayViaRoadshow = (replayMethod: CallReplayMethod) => (replayMethod === CallReplayMethod.Roadshow);
}

export default CallEvent;
